import React from "react";
import Carousel from "./Carousel";
import Cards from "./Card";
import Imgvideo from "./Imgvideo";
import Contact from "./Contact";
import AfterLogin from "./AfterLogin";
import img from '../Assets/homeo.jpg';

const Landing = () => {
  return (
    <div>
      <Carousel />

      <div className="d-flex justify-content-around flex-wrap mt-5 mb-5 gap-3">

        <Cards
          icon={<i className="fa-solid fa-unlock fa-5x text-white p-3"></i>}
          name="FULL ACCESS"
          cardtext="Unlock unlimited access to a wealth of resources designed to enhance your learning experience."
          readmore="Read more"
          linkTo="/customer/packages?type=Full Access"
        />

        <Cards
          icon={<i className="fa-solid fa-money-bill fa-5x text-white p-3"></i>}
          name="MONTHLY SUBSCRIPTION"
          cardtext="Subscribe monthly to gain flexible access to all our premium content."
          readmore="Read more"
          linkTo="/customer/packages?type=Monthly Subscription"
        />

        <Cards
          icon={<i className="fa-solid fa-file fa-5x text-white p-3"></i>}
          name="BUY A CHAPTER"
          cardtext="Purchase individual chapters tailored to your learning needs."
          readmore="Read more"
          linkTo="/customer/packages?type=Chapter-wise Subscription"
        />

      </div>

      <Imgvideo />
      <Contact />
    </div>
  );
};

export default Landing;
